var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30324 21.315C6.70168 21.7251 7.39308 21.7134 7.79152 21.315L13.7915 15.3032L19.8032 21.315C20.2017 21.7134 20.8814 21.7251 21.2798 21.315C21.7017 20.9048 21.69 20.2251 21.2798 19.8267L15.2798 13.815L21.2798 7.81496C21.69 7.41652 21.7017 6.72511 21.2798 6.32668C20.8814 5.91652 20.2017 5.92824 19.8032 6.32668L13.7915 12.3384L7.79152 6.32668C7.39308 5.92824 6.70168 5.91652 6.30324 6.32668C5.89308 6.72511 5.9048 7.41652 6.30324 7.81496L12.315 13.815L6.30324 19.8267C5.9048 20.2251 5.89308 20.9048 6.30324 21.315Z",
    fill: "currentColor",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.02ab8b616accbd4e5e3f669aba1c9f28.svg";
export { ForwardRef as ReactComponent };